import React, { useEffect } from 'react';
import { useHistory } from "react-router-dom";

import { WrapperSegment } from 'shared-one-ux-components';

export default function ClientScopes({ projectDetails, carDetailsLoading, openFocusPane, isDomainSubCategoryBusy, disableAddApisBtn, filteredApis, events, setSelectedSegment }) {
	const [pendingApproval, setPendingApproval] = React.useState(false);
	const hasFilteredApis = (filteredApis.length > 0) && (!carDetailsLoading);
	const history = useHistory();
	const { clientProjectDetails, ...otherProjectDetail } = projectDetails;
	const projectDetail = { ...otherProjectDetail, ...clientProjectDetails };

	useEffect(() => {
		if (projectDetail && projectDetail.clientOOID) {
			if (projectDetail.status === 'CLIENT_APP_SUBSCRIBED' || projectDetail.changeRequests.length > 0) {
				setPendingApproval(true);
			}
		}
	}, [projectDetail]);


	return (
		<div>
			<div className="flex justify-between mb-4">
				<WrapperSegment
					loading={carDetailsLoading}
					history={history}
					projectType={'self_service_si_project'}
					projectDetail={projectDetail}
					events={events}
					filteredApis={filteredApis}
					hasFilteredApis={hasFilteredApis}
					title='APIs'
					openFocusPane={openFocusPane}
					setSelectedSegment={setSelectedSegment}
					changeHistoryRedirectUrl={`/accelerator-projects/${projectDetail.clientOOID}/change-history/${projectDetail._id}`}
					isDomainSubCategoryBusy={isDomainSubCategoryBusy}
					disableAddApisBtn={disableAddApisBtn || pendingApproval}
				/>
			</div>
		</div>
	);
}
